export function rejectionReasonToError(reason: unknown): Error {
  if (reason instanceof Error) {
    return reason;
  }

  if (typeof reason === 'string') {
    return new Error(reason);
  }

  if (reason == null) {
    return new Error(`Unhandled promise rejection (${reason})`);
  }

  if (
    typeof reason === 'object' &&
    'message' in reason &&
    typeof reason.message === 'string'
  ) {
    return new Error(reason.message);
  }

  try {
    const serializedReason = JSON.stringify(reason);

    if (serializedReason && serializedReason !== '{}') {
      return new Error(`Unhandled promise rejection: ${serializedReason}`);
    }
  } catch {}

  return new Error(`Unhandled promise rejection: ${String(reason)}`);
}
